import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { useTheme } from './useTheme';
import { useIsMobile } from './useIsMobile';
import { PageHeaderProvider } from './PageHeaderContext';
import { useOsNotifier } from './useOsNotifier';
import { useAuth } from '@/auth/useAuth';

export function AppLayout() {
  const { sidebarCollapsed } = useTheme();
  const isMobile = useIsMobile();
  const { user } = useAuth();
  // Polls the notifications endpoint and fires an OS-level popup for any
  // brand-new item — so the receiver of a handoff (or any push) sees a
  // Windows notification, not just the in-app bell.
  useOsNotifier(!!user);
  return (
    <PageHeaderProvider>
      {/* flow-root establishes a BFC so <main>'s top margin (which clears the
          fixed Topbar) can't collapse through the wrapper and pull page content
          up behind the Topbar. */}
      <div style={{ display: 'flow-root' }}>
        <Sidebar />
        <Topbar />
        <main
          className="mt-12 h-[calc(100vh-48px)] overflow-x-hidden overflow-y-auto px-2 pt-1 pb-0 sm:px-3 sm:pt-1.5 md:mt-16 md:h-[calc(100vh-64px)] md:px-4 md:pt-2"
          style={{
            marginLeft: isMobile ? 0 : sidebarCollapsed ? '64px' : '240px',
            transition: 'margin-left 300ms',
          }}
        >
          <Outlet />
        </main>
      </div>
    </PageHeaderProvider>
  );
}
